export default __webpack_public_path__ + "static/media/More-category-mobile.7ba9ffd4.png";